import { render, staticRenderFns } from "./component-img-link.vue?vue&type=template&id=3f9e9270&"
import script from "./component-img-link.vue?vue&type=script&lang=js&"
export * from "./component-img-link.vue?vue&type=script&lang=js&"
import style0 from "./component-img-link.vue?vue&type=style&index=0&id=3f9e9270&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports